import React from 'react';

export default function InvalidUrl() {
  return <div style={{ padding: "1rem", margin: '0 auto', textAlign: 'center'}}>
            <h2>This Page Isn't Available</h2>
            <p>The link may be broken, or the page may have been removed. Check to see if the link you're trying to open is correct.</p>
          </div>
}